export default __webpack_public_path__ + "static/media/insulin-evening-icon.c3e15310.svg";